import React from "react";
import partners from "../../data/partners.json";
import "./marquee.css";

const MarqueeSection = () => {
  const logos = partners;

  return (
    <div className="bg-[#f8f9fb] py-5 md:py-10 flex flex-col items-center">
      <div className="max-w-7xl w-full text-center">
        <h3 className="mb-4 text-2xl font-bold md:text-4xl text-[#da2128]">
          Our Partners
        </h3>

        <div className="marquee-wrapper">
          <div className="marquee-track">
            {/* Multiple sets for seamless infinite scroll */}
            {[...logos, ...logos, ...logos, ...logos].map((partner, index) => (
              <a
                key={`${partner.name}-${index}`}
                href={partner.url}
                target="_blank"
                rel="nofollow"
                className="flex items-center justify-center bg-white p-3 rounded-md shadow-md min-w-[120px] transition hover:scale-105"
              >
                <img src={partner.icon} alt={partner.name} className="h-8 object-contain" />
              </a>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MarqueeSection;
